function setPriceIva() {
    let value = $('#batteries_model_list_price').val()
    if(!undefinedOrNull(value) && value !== ''){
        let price = parseInt(value)
        let iva = price * 0.16
        $('#batteries_model_list_price_iva').val(price + iva)
    }
}

function destroyBatteriesModel() {
    if(document.getElementById('batteries_model_form')) {
        $(document).off('change', '#batteries_model_list_price', setPriceIva)
    }
}

function setupBatteriesModel() {
    if(document.getElementById('batteries_model_form')) {
        $(document).on('change', '#batteries_model_list_price', setPriceIva)
    }
}

$(document).on('turbolinks:load', setupBatteriesModel)
window.addEventListener('beforeunload', (event) => {
    destroyBatteriesModel();
});